import ContextMenuComponent from '../../../../context-menu'
import {
  contextMenuArrowAlignmentOptions,
  contextMenuAlignOptions
} from '../../../../context-menu/constants'
import SearchComponent from '../../../../../molecules/search'
import { searchVariantsOptions } from '../../../../../molecules/search/constants'
import {
  QuickSelectListContent,
  SearchContainer,
  QuickSelectListContainer,
  LoadingContainer
} from '../../../styled-components'
import { useIntl } from 'react-intl'
import { Search } from '../../../../../atoms/icons/core'

import { iconSizeOptions } from '../../../../../atoms/icons/icons-sizes.js'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../../../../fundamentals/text-styles/constants.js'
import { SpinnerGrey } from '../../../../../atoms/icons/special/index.js'
import { forwardRef } from 'react'

const QuickSelectList = forwardRef(
  (
    {
      setSearchValue = () => {},
      searchValue,
      isLoading = false,
      children,
      ...props
    },
    forwardedRef
  ) => {
    const { formatMessage } = useIntl()

    const LoadingComponent = () => {
      return (
        <LoadingContainer>
          <SpinnerGrey size={iconSizeOptions['ICON-XL']} />
        </LoadingContainer>
      )
    }

    const ListItems = () => {
      if (isLoading) return <LoadingComponent />

      return children
    }

    return (
      <QuickSelectListContainer {...props}>
        <ContextMenuComponent.List
          width={'400px'}
          align={contextMenuAlignOptions.END}
          arrowAlignment={contextMenuArrowAlignmentOptions.START}
          hideScrollbar
          maxHeight={'500px'}
          height={'500px'}
          ref={forwardedRef}
        >
          <QuickSelectListContent>
            <SearchContainer>
              <SearchComponent.Root
                placeholder={formatMessage({ id: 'search' })}
                variant={searchVariantsOptions.DESKTOP}
                setSearchValue={setSearchValue}
                searchValue={searchValue}
                defaultDesktopVariantOpen={true}
                startFocued
              >
                <SearchComponent.Container>
                  <SearchComponent.LeadingIcon
                    icon={Search}
                    size={iconSizeOptions['ICON-S']}
                    style={{
                      marginLeft: '8px'
                    }}
                  />
                  <SearchComponent.Input
                    style={{
                      ...textStyleSizeStyleOptions[
                        textStyleSizeOptions['TEXT-R']
                      ],
                      ...textStyleWeightStyleOptions[
                        textStyleWeightOptions['TEXT-500']
                      ]
                    }}
                  />
                  <SearchComponent.ClearButton />
                </SearchComponent.Container>
                <SearchComponent.CancelButton />
              </SearchComponent.Root>
              <ContextMenuComponent.Divider />
            </SearchContainer>

            <ListItems />
          </QuickSelectListContent>
        </ContextMenuComponent.List>
      </QuickSelectListContainer>
    )
  }
)

QuickSelectList.displayName = 'QuickSelectList'
export default QuickSelectList
